export const ANALYTICS_TITLE = "Agent Benchmarks Setup";
export const ANALYTICS_SUBTITLE = "Benchmark targets per agent state. Customize as needed.";
export const ANALYTICS_TOOLTIP =
  "Customize the benchmarks displayed in your agent's analytics pages. Take agent maturity and skills setup into account to match the right benchmarks.";

export const BENCHMARKS_TABLE_COLUMNS = [
  { field: "metricName", headerName: "Metric", flex: 1 },
  { field: "benchmark", headerName: "Benchmark", flex: 1 },
  { field: "type", headerName: "Type", flex: 1 }
];

export const BENCHMARK_TYPES = {
  DEFAULT: "Default",
  CUSTOM: "Custom"
};

export const BENCHMARK_MAX = 100;
export const BENCHMARK_VALIDATION_ERROR = "Value must be between 0 and 100";
export const DAYS_BENCHMARK_MAX = 365;
export const DAYS_BENCHMARK_VALIDATION_ERROR = "Value must be between 0 and 365";

export const SCHEDULING_TIME_TO_APPOINTMENT_METRIC_ID = "SCHEDULING_TIME_TO_APPOINTMENT";

export const RATIO_BENCHMARK_FORMAT = {
  unit: "%",
  max: BENCHMARK_MAX,
  validationError: BENCHMARK_VALIDATION_ERROR,
  toDisplay: (benchmark) => Math.round(benchmark * 100),
  fromDisplay: (displayValue) => displayValue / 100
};

export const BENCHMARK_FORMATS_BY_METRIC_ID = {
  [SCHEDULING_TIME_TO_APPOINTMENT_METRIC_ID]: {
    unit: "d",
    max: DAYS_BENCHMARK_MAX,
    validationError: DAYS_BENCHMARK_VALIDATION_ERROR,
    toDisplay: (benchmark) => Math.round(benchmark),
    fromDisplay: (displayValue) => displayValue
  }
};

export const SWITCH_SETUP_BODY = "Switching setups will apply new default benchmark values.";
export const SWITCH_SETUP_BODY_WITH_CUSTOMS =
  "Switching setups will apply new default benchmark values.\nDo you want to keep the benchmark values you've already customized when switching to the new setup?";
export const SWITCH_SETUP_CHECKBOX_LABEL = "Keep my custom benchmarks";
export const SWITCH_SETUP_SUBMIT = "Switch Setup";

export const VALUE_REFERENCES_TITLE = "Value References";
export const VALUE_REFERENCES_SUBTITLE =
  "Dollar values used to calculate value generated metrics. Customize as needed.";

export const VALUE_REFERENCES_TABLE_COLUMNS = [
  { field: "metricName", headerName: "Metric", flex: 1 },
  { field: "value", headerName: "Benchmark", flex: 1 },
  { field: "type", headerName: "Type", flex: 1 }
];

export const VALUE_REFERENCE_MAX = 999999;
export const VALUE_REFERENCE_VALIDATION_ERROR = "Value must be between 0 and 999,999";
